var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{staticClass:"MatchSet"},[_c('fieldset',[_c('legend',{class:[
        { 'font-weight-bold': _vm.titleBold },
        'v-div',
        'title',
        `${_vm.titleColor}--text`,
      ]},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_vm._l((_vm.buckets),function(bucket){return _c('MatchBucket',{key:bucket.key,attrs:{"bucket":bucket,"selected":_vm.selected},on:{"selectionChanged":function($event){return _vm.$emit('selectionChanged', $event)}}})}),_vm._v(" "),_c('v-div',{attrs:{"border-bottom-inverted-thick":"","mt-3":"","ml-1":"","mr-1":""}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }